import "slick-carousel";
import "magnific-popup";
import Isotope from "isotope-layout";
import watchHeight from "./watchHeight";
import { scrollToAnchorOnClick, scrollListener } from "./scrollListener";
import featuredEventsSlider from "./featuredEventsSlider";
import navMenuFocusTrap from "./focusTrap";
import heroSlider from "./heroSlider";
// core version + navigation, pagination modules:

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed

scrollListener({ switchAt: 140 });

watchHeight({
  selector: "#alert-bar-desktop",
  prop: "--alert-bar-desktop-height",
});

watchHeight({
  selector: "#alert-bar-mobile",
  prop: "--alert-bar-mobile-height",
});

homeSlider();

eventsIsotope();

featuredEventsSlider(); // currently in use on hp (mobile only)

heroSlider();
// handleMobileMenu();

navTrigger();
navMenuFocusTrap();

accordion();

historyPopups();

videoPopups();

expandEventContent();

function homeSlider() {
  $(".slider .slider__slides").slick({
    dots: false,
    dotsClass: "slick-dots",
    arrows: true,
    prevArrow: '<button type="button" class="slick-prev"></button>',
    nextArrow: '<button type="button" class="slick-next"></button>',
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    fade: true,
    respondTo: "slider",
    centerMode: true,
  });
}

function eventsIsotope() {
  const events = document.querySelector(".events");
  const stickyHeader = document.querySelector(".main .main__head");
  const eventsListing = document.querySelector("#events-listing");
  let filters = {};

  if (events != null) {
    const iso = new Isotope(events, {
      itemSelector: ".events__day, .date-banner__container, .event",
      percentPosition: true,
      layoutMode: "fitRows",
    });

    // Combine filters
    function concatValues(obj) {
      let value = "";
      for (let prop in obj) {
        value += obj[prop];
      }
      return value;
    }
    function updateDateBannersVisibility() {
      // For each date group wrapper
      events.querySelectorAll(".events-group__wrapper").forEach((container) => {
        // Find visible events inside this date group
        const visibleEvents = container.querySelectorAll(
          '.event:not([style*="display: none"])'
        );
        // Hide the whole group if no events are visible
        container.style.display = visibleEvents.length
          ? ""
          : iso.remove("remove", container);

        iso.remove(container);
      });
    }

    // Handle filter changes
    $(".events-filter").on("change", "input, select", function (e) {
      let $this = $(this);
      let filterValue = "";
      let filteredItems = [];

      const noResults = events.querySelector(".events__no-results");
      if (noResults) {
        noResults.remove(); // Remove the no results message
      }

      if ($this.parents("li").hasClass("active")) {
        $this.parents("li").removeClass("active");

        filterValue = "*";

        updateDateBannersVisibility();
        iso.arrange({ filter: filterValue });
      } else {
        $this.parents("li").addClass("active").siblings().removeClass("active");

        // get group key
        const $buttonGroup = $this.parents(".filter-group");
        const filterGroup = $buttonGroup.attr("data-filter-group");

        filters[filterGroup] =
          $this.find(":selected").data("filter") || $this.attr("data-filter");

        filterValue = concatValues(filters);
        updateDateBannersVisibility();
        iso.arrange({ filter: filterValue });

        filteredItems = iso.getFilteredItemElements();

        if (filteredItems.length === 0) {
          events.insertAdjacentHTML(
            "beforeend",
            `<div class="events__no-results centered" style="width: 100%; margin-top: 2rem;">
            <h2>Sorry, no events match your search.</h2>
            <h3>Try changing your filters.</h3>
          </div>`
          );
        }
      }
    });
  }
}

function navTrigger() {
  $(".nav-trigger button").on("click", function (e) {
    $("body").toggleClass("mobile-nav-open");
    $(this).toggleClass("active");
    $(this).attr("aria-expanded", function (i, attr) {
      return attr === "true" ? "false" : "true";
    });
    e.preventDefault();
  });

  $(".menu-item a").on("click", function (e) {
    if (
      $("body").hasClass("mobile-nav-open") &&
      !$(this).parent().hasClass("menu-item-has-children")
    ) {
      $("body").removeClass("mobile-nav-open");
      $(".nav-trigger button").removeClass("active");
      $(".nav-trigger button").attr("aria-expanded", "false");
    }
  });
}

function isMobile() {
  return /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

function accordion() {
  $(".accordion__head").on("click", function (e) {
    $(this)
      .next()
      .slideToggle()
      .parent()
      .toggleClass("accordion__section--expanded")
      .siblings()
      .removeClass("accordion__section--expanded")
      .find(".accordion__body")
      .slideUp();
    e.preventDefault();
  });
}

function historyPopups() {
  $(".timeline .timeline__event, .header__link a[href^=#]").magnificPopup({
    type: "inline",
  });
}

function videoPopups() {
  $(".section__videos a").magnificPopup({
    type: "iframe",
  });
}

function expandEventContent() {
  $(".section-event .link-more").on("click", function (e) {
    $(this)
      .parents(".section__artist")
      .toggleClass("section__artist--expanded");
    e.preventDefault();
  });
}
